

<template>
  <div class="page2">
     <div class="h90"></div>
     <div class="content">
        <div class="title1" :class="{'ani_left': ani_left}">{{msg}}</div>
        <div class="title2">具有一站式、智能设备、IOS、Android开发能力</div>
        <div class="iCloud">
            <img :src="url + '/assets/icon-iCloud.png'">
            iCloud
        </div>
        <div class="list">
            <ul>
                <li>
                    <img :src="url + '/assets/icon-collection.png'">
                    <p>采集终端</p>
                </li>
               <li>
                    <img :src="url + '/assets/icon-gps.png'">
                    <p>gps定位设备</p>
                </li>
                <li>
                    <img :src="url + '/assets/icon-antenna.png'">
                    <p>智能天线</p>
                </li>
                <li>
                    <img :src="url + '/assets/icon-temperature.png'">
                    <p>温度采集器</p>
                </li>
                <li>
                    <img :src="url + '/assets/icon-environmental.png'">
                    <p>环境监测</p>
                </li>
                <li class="none">
                    <img :src="url + '/assets/screen.png'">
                    <p>大屏数据</p>
                </li>
            </ul>
        </div>
     </div>
  </div>
</template>
<script>
import defaultSettings from '@/defaultSettings'
export default {
    name: 'page2',
  data() {
    return {
        url: defaultSettings.url,
        msg: ''
    }
  },
   props:{
    ani_left: {
        type: [Boolean],
        require: false,
        default: false,
    },
  },
  watch: {
    ani_left (value) {
        if (value) {
            return this.msg = '野马智能物联整体解决方案专家'
        } else {
            this.msg = ''
        }
    }
  },
  created() {},
  mounted() {
  },
  methods: {
  }
};
</script>
<style lang="less" scoped>
.bounceInUp {
  -webkit-animation-name: bounceInUp;
  animation-name: bounceInUp;
}
.page2 {
    margin:0 auto;
    text-align: center;
    .h90{
        height:90px;
    }
    .content{
        width:1200px;
        margin:0 auto;
        .title1{
            height:100px;
            margin-top:18vh;
            font-size: 60px;
            font-weight: bold;
            color: #333;
        }
        .title2{       
            font-size: 28px;
            color: #333;
            margin-top:30px;
        }
        .iCloud{
            margin-top:90px;
            font-size: 32.5px;
            color:#333;
            img{
                width:74px;
                height:80px;
                vertical-align: middle;
            }
        }
        .list{
            margin-top:40px;
            ul {
                li{
                    display: inline-block;
                    margin-right:50px;
                    p{
                        color:#333;
                        font-size:16px;
                        margin-top:13px;
                    }
                    img{
                        width:87px;
                        height:87px;
                    }
                }
                .none{
                   margin-right:0px;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/page2.vue